import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEmptyState = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 429,
	height: 233,
	viewBox: "0 0 429 233",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_1119_8037)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M345.56 54.7402C352.19 54.7402 357.57 60.1202 357.57 66.7502C357.57 73.3802 352.19 78.7602 345.56 78.7602H276.92C283.55 78.7602 288.93 84.1402 288.93 90.7702C288.93 97.4002 283.55 102.78 276.92 102.78H314.67C321.3 102.78 326.68 108.16 326.68 114.79C326.68 121.42 321.3 126.8 314.67 126.8H297.21C288.85 126.8 282.06 132.18 282.06 138.81C282.06 143.23 285.49 147.24 292.36 150.82C298.99 150.82 304.37 156.2 304.37 162.83C304.37 169.46 298.99 174.84 292.36 174.84H149.94C143.31 174.84 137.93 169.46 137.93 162.83C137.93 156.2 143.31 150.82 149.94 150.82H83.01C76.38 150.82 71 145.44 71 138.81C71 132.18 76.38 126.8 83.01 126.8H151.65C158.28 126.8 163.66 121.42 163.66 114.79C163.66 108.16 158.28 102.78 151.65 102.78H108.75C102.12 102.78 96.74 97.4002 96.74 90.7702C96.74 84.1402 102.12 78.7602 108.75 78.7602H177.39C170.76 78.7602 165.38 73.3802 165.38 66.7502C165.38 60.1202 170.76 54.7402 177.39 54.7402H345.56ZM345.56 102.79C352.19 102.79 357.57 108.17 357.57 114.8C357.57 121.43 352.19 126.81 345.56 126.81C338.93 126.81 333.55 121.43 333.55 114.8C333.55 108.17 338.93 102.79 345.56 102.79Z",
				fill: "#E8E5FF"
			}),
			/* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M254.05 53.0195L270.01 169.44L271.44 181.12C271.9 184.88 269.23 188.31 265.46 188.77L164.97 201.11C161.21 201.57 157.78 198.9 157.32 195.13L141.85 69.1295C141.62 67.2495 142.96 65.5395 144.84 65.2995H144.88L153.22 64.3595",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M256.169 52.73C256.009 51.56 254.929 50.73 253.749 50.9C252.579 51.06 251.759 52.14 251.919 53.32L256.169 52.74V52.73ZM270.009 169.44L272.139 169.18V169.15L270.009 169.44ZM153.449 66.5C154.629 66.37 155.469 65.31 155.339 64.13C155.209 62.95 154.149 62.1 152.969 62.24L153.449 66.5ZM159.709 61.48C158.529 61.61 157.689 62.67 157.819 63.85C157.949 65.03 159.009 65.87 160.189 65.74L159.709 61.48ZM168.059 64.86C169.239 64.73 170.079 63.67 169.949 62.49C169.819 61.31 168.759 60.46 167.579 60.6L168.059 64.86ZM251.909 53.32L267.869 169.74L272.119 169.16L256.159 52.74L251.909 53.32ZM267.869 169.71L269.299 181.39L273.559 180.87L272.129 169.19L267.869 169.71ZM269.299 181.39C269.619 183.98 267.779 186.33 265.189 186.65L265.709 190.91C270.649 190.3 274.159 185.81 273.549 180.87L269.289 181.39H269.299ZM265.189 186.65L164.699 198.99L165.219 203.25L265.709 190.91L265.189 186.65ZM164.699 198.99C162.109 199.31 159.759 197.47 159.439 194.88L155.179 195.4C155.789 200.34 160.279 203.85 165.219 203.24L164.699 198.98V198.99ZM159.439 194.88L143.969 68.88L139.709 69.4L155.179 195.4L159.439 194.88ZM143.969 68.88C143.879 68.17 144.379 67.53 145.089 67.45L144.569 63.19C141.509 63.57 139.339 66.35 139.709 69.41L143.969 68.89V68.88ZM145.089 67.45H145.099L144.619 63.19C144.619 63.19 144.579 63.19 144.559 63.19L145.079 67.45H145.089ZM145.099 67.45L153.439 66.51L152.959 62.25L144.619 63.19L145.099 67.45ZM160.179 65.76L168.049 64.88L167.569 60.62L159.699 61.5L160.179 65.76Z",
				fill: "#8254FF"
			}),
			/* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M249.702 60.3496L264.152 165.86L265.452 176.45C265.872 179.86 263.482 182.96 260.112 183.37L170.122 194.42C166.752 194.83 163.682 192.41 163.262 188.99L149.272 75.0896C149.042 73.2096 150.382 71.4996 152.262 71.2696L163.392 69.8996",
				fill: "#F8F7FF"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M175.539 35.8596C175.539 33.2496 177.649 31.1396 180.259 31.1396H258.439C259.689 31.1396 260.889 31.6396 261.779 32.5196L284.849 55.5696C285.729 56.4596 286.229 57.6596 286.229 58.9096V166.27C286.229 168.88 284.119 170.99 281.509 170.99H180.259C177.649 170.99 175.539 168.88 175.539 166.27V35.8596Z",
				fill: "white",
				stroke: "#8254FF",
				strokeWidth: 4.29
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M259.199 33.1201V53.0201C259.199 55.8601 261.499 58.1701 264.349 58.1701H277.959",
				stroke: "#8254FF",
				strokeWidth: 4.29,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M211 80.5232C211 80.5232 214.536 65 229.413 65C245.741 65 255.664 82.6122 246.499 94.3206C245.757 95.2619 240.078 100.456 239.198 101.248C233.161 106.673 230.195 115.615 230.22 124.533V129",
				stroke: "#8254FF",
				strokeWidth: 8,
				strokeLinecap: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M230.946 144.888C233.501 144.827 235.522 142.706 235.461 140.151C235.399 137.596 233.278 135.575 230.723 135.637C228.169 135.698 226.148 137.819 226.209 140.374C226.271 142.929 228.392 144.95 230.946 144.888Z",
				fill: "#8254FF"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_1119_8037",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 286.57,
			height: 174.31,
			fill: "white",
			transform: "translate(71 29)"
		})
	}) })]
});
export default SvgEmptyState;
